export default __webpack_public_path__ + "static/media/icon-31.53b6b0e9.png";